import { Activity, Renew } from '@api'
import { z } from 'zod'

export type CustomListFormValues = z.infer<typeof CustomListFormSchema>

export const CustomListFormSchema = z.object({
  name: z
    .string({
      required_error: 'List name is required',
    })
    .min(1, { message: 'List name is required' }),
  activity: z
    .enum([Activity.ALL, Activity.ACTIVE, Activity.EXPIRED])
    .optional()
    .nullable(),
  amountSpent: z.coerce
    .number()
    .min(1, { message: 'Amount spent is required' })
    .int('Amount spent should be an valid number')
    .positive('Amount spent should be a positive number')
    .optional()
    .nullable(),
  spendMoneyLastNDays: z.coerce
    .number()
    .int('Spend money last X days should be an valid number')
    .positive('Spend money last X days should be a positive number')
    .min(1, {
      message: 'Spend money last X days is required',
    })
    .max(30, {
      message: 'Spend money last X days cannot be greater than 30 days.',
    })
    .optional()
    .nullable(),
  timeSubscribedDays: z.coerce
    .number()
    .int('Time subscribed days should be an valid number')
    .positive('Time subscribed days should be a positive number')
    .min(1, {
      message: 'Time subscribed days is required',
    })
    .max(30, {
      message: 'Time subscribed days cannot be greater than 30 days.',
    })
    .optional()
    .nullable(),
  listIds: z.array(z.string()).optional().nullable(),
  atLeastRespondedOnceInLastNDays: z.coerce
    .number()
    .int('At least responded once in last X days should be an valid number')
    .positive(
      'At least responded once in last X days should be a positive number',
    )
    .min(1, {
      message: 'At least responded once in last X days is required',
    })
    .max(30, {
      message: 'Replied in last X days cannot be greater than 30 days.',
    })
    .optional()
    .nullable(),
  renew: z.enum([Renew.BOTH, Renew.ON, Renew.OFF]).optional().nullable(),
  amountOfTips: z.coerce
    .number()
    .int('Amount of tips should be an valid number')
    .positive('Amount of tips should be a positive number')
    .min(1, { message: 'Amount of tips is required' })
    .optional()
    .nullable(),
  countOfPpvBought: z.coerce
    .number()
    .int('Count of ppv bought should be an valid number')
    .positive('Count of ppv bought should be a positive number')
    .min(1, {
      message: 'Count of ppv bought is required',
    })
    .optional()
    .nullable(),
})
